import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import HeaderState from "@sonic/Store/Pages/Header/HeaderState";
import { Draft } from "immer";

const initialState: HeaderState = {
    isSecondaryHeader: false,
    isActive: false,
};

const reducer = {
    "Pages/Header/UpdateHeaderState": (draft: Draft<HeaderState>, action: { parameter: HeaderState }) => {
        draft.isSecondaryHeader = action.parameter.isSecondaryHeader;
    },
    "Pages/Header/UpdateHeaderActive": (draft: Draft<HeaderState>, action: { parameter: HeaderState }) => {
        draft.isActive = action.parameter.isActive;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
